import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class VersionService {
  private readonly _backendVersion = signal<string | null>(null);
  readonly backendVersion = this._backendVersion.asReadonly();

  setBackendVersion(version: string): void {
    if (version && this._backendVersion() !== version) {
      this._backendVersion.set(version);
    }
  }
}
